import type {ReactElement} from 'react';
import React from 'react';
import App from '@Components/app';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {ModalContainer} from '@Components/modal-container';
import {PosterEditorPage} from '@Components/poster-editor-page';
import type {PosterEditorConfig} from '@Components/poster-editor/poster-editor.types';
import type {PosterOpts} from '@PosterWhiteboard/poster/poster.class';
import {useLoadI18} from '@Hooks/useLoadI18';
import {renderApp} from '@Utils/renderApp.util';

interface ReactPageProps {
  posterEditorConfig: PosterEditorConfig;
  posterOpts: PosterOpts;
}

const reactPageProps = window.reactPageProps as ReactPageProps;

function PosterMakerApp(): ReactElement | null {
  const i18Loaded = useLoadI18();

  if (!i18Loaded) {
    return <App />;
  }

  return (
    <App
      nonStrickModeChildren={
        <PosterEditorPage isEmbedded={window.PMW.isEmbedded()} posterOpts={reactPageProps.posterOpts} posterEditorConfig={reactPageProps.posterEditorConfig} />
      }
    >
      <ModalContainerDeprecated />
      <ModalContainer />
    </App>
  );
}

renderApp(<PosterMakerApp />, 'pmw-app');
